<template>
  <OmtLayoutHeaderFooter
    :footer="false"
    :header="{ titleLabel: 'Autenticação por biometria' }"
  >
    <OmtGrid>
      <OmtRow mb="24px">
        <OmtIcons
          name="face-viewfinder"
          size="3x"
          color="var(--colors-light-primary-navy-blue)"
        />
      </OmtRow>

      <OmtRow mb="24px">
        <OmtTypography as="h1-bold"> Validação de biometria </OmtTypography>
      </OmtRow>

      <OmtRow mb="24px">
        <BiometryAuthCard />
      </OmtRow>

      <OmtRow mb="32px">
        <BiometryCameraButton
          :disabled="false"
          buttonLabel="Click para validar autenticação"
          :confirmUser="true"
          :nameUser="nomeIdentificacao"
          @success="handleBiometryCameraSuccess"
          @error="handleBiometryCameraError"
          @resourceError="handleResourceError"
          @startLoading="$root.$emit('show-loading')"
          @endLoading="$root.$emit('hide-loading')"
        />
      </OmtRow>
    </OmtGrid>
  </OmtLayoutHeaderFooter>
</template>

<script>
import BiometryCameraButton from "@/components/Organisms/Biometry/BiometryCameraButton";
import BiometryAuthCard from "@/components/Organisms/Biometry/BiometryAuthCard";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    BiometryCameraButton,
    BiometryAuthCard
  },
  computed: {
    ...mapState("firstAccess", ["cadastrarEmail", "hash", "nomeIdentificacao"])
  },
  mounted() {
    if (!this.hash) {
      this.$router.replace({
        name: "first-access.terms"
      });
    }
  },
  methods: {
    ...mapActions("firstAccess", ["authFace", "registerError"]),
    async handleBiometryCameraSuccess(payload) {
      try {
        const { encrypted } = payload;
        await this.$root.$emit("show-loading");
        const data = await this.authFace({ selfie: encrypted });
        if (data?.Autorizado) {
          this.$toast({
            description: "Autenticação realizada com sucesso",
            status: "success",
            duration: 10000,
            position: "top"
          });
          this.$router.push({ name: this.cadastrarEmail ? "first-access.mailform" : "first-access.password" });
          return;
        }

        this.continueToEmail();
      } catch (error) {
        globalThis.window.$log.error("biometry page", error);
        this.continueToEmail();
      } finally {
        await this.$root.$emit("hide-loading");
      }
    },
    continueToEmail() {
      this.$router.push({ name: this.cadastrarEmail ? "first-access.mailform" : "first-access.mailcheck" });
    },
    handleResourceError(error) {
      globalThis.window.$log.error("biometry init", error);
      this.$toast({
        description: "Ocorreu um erro ao iniciar a câmera",
        status: "error",
        duration: 10000,
        position: "top"
      });
      this.registerError({ cod: "init", dsc: JSON.stringify(error) });
    },
    handleBiometryCameraError(error) {
      globalThis.window.$log.error("biometry camera", error);
      this.registerError({ cod: "camera", dsc: JSON.stringify(error) });
    }
  }
};
</script>
